/**
 * @group Action
 * @summary <blockquote>Server action operation names.</blockquote>
 */
export const ACTION_OPERATIONS = {
  FETCH: 'fetch operation',
  SAVE: 'save operation',
  DELETE: 'delete operation',
  CREATE: 'create operation',
  UPDATE: 'update operation',
} as const; 